import { useTranslation } from '../../hooks';

export function RecordsTableHeader() {
  const { t } = useTranslation();
  return (
    <thead>
      <tr className="fw-bold text-nowrap">
        <th scope="col" className="text-center p-1 w-25">
          {t('DATE & HOUR')}
        </th>
        <th scope="col" className="text-center p-1">
          {t('Type')}
        </th>
        <th scope="col" className="text-center p-1">
          {t('Lambda')}
        </th>
        <th scope="col" className="text-center p-1">
          {t('Version')}
        </th>
        <th scope="col" className="text-center p-1">
          {t('MESSAGE')}
        </th>
        <th scope="col" className="text-center p-1">
          {t('ACTIONS')}
        </th>
      </tr>
    </thead>
  );
}

export default RecordsTableHeader;
